"use strict";
export const GRID_AREAS = {
  HEADER: "header",
  MAIN: "main",
  FOOTER: "footer",
  MOBILE_BOTTOM_BAR: "mobile-bar"
};
